import React, { Component } from 'react';
import moment from 'moment'

import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


class Recommend extends Component {
  renderProgress() {
    const task = this.props.item
    return <Row>
      <Col sm={12} className='RecommendDetail'>
        {task.data.completed && <span>
          <Badge variant='success'>完了</Badge>{' '}
        </span>}
        {!task.data.completed && <span>
          <Badge variant='danger'>途中</Badge>{' '}
        </span>}
        {parseInt(task.data.rate * 100)}%
        &nbsp;
        ベストスコア: {task.data.score} / {task.data.scoreTotal}
      </Col>
      <Col sm={12} className='RecommendType'>
        <a href={`${this.props.baseURL}/?task_id=${task.id}&quiz=1`}>
          <Badge variant='info'>→単語クイズ</Badge>
        </a>
      </Col>
    </Row>
  }

  render() {
    const task = this.props.item
    const param = this.props.type === 'cloze' ? 'v2' : 'quiz'
    const typeFace = this.props.type === 'cloze' ? null : '単語クイズ'
    const accessed = this.props.type === 'cloze' ? task.data.accessed : task.data.quizAccessed
    const imgsrc = this.props.imgsrc || null
    const cardContent = <Container>
      <Row>
        <Col sm={12}>
          {typeFace && <span>
              <Badge variant='primary'>{typeFace}</Badge>{' '}
            </span>}
          <span className='RecommendHeader'>
            <a href={`${this.props.baseURL}/?task_id=${task.id}&${param}=1`}>{task.data.title}</a>
          </span>
        </Col>
        <Col sm={12} className='RecommendAccessed'>
          最終アクセス:
          {accessed ? moment(new Date(accessed)).fromNow() : '-'}
        </Col>
      </Row>
      {this.props.progress && this.renderProgress()}
    </Container>
    return <div className='RecommendCard h-100'>
      <Card className='h-100'>
        {imgsrc ? (<>
            <Card.Img src={imgsrc} />
            <Card.ImgOverlay>{cardContent}</Card.ImgOverlay>
          </>) :
          (<Card.Body>{cardContent}</Card.Body>)}
      </Card>
    </div>
  }
}

export default Recommend;
